import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import Head from '@alweb-merkator/shared/components/Head';
import { Styles } from './styles';

const Protocolo = () => {
  const { t } = useTranslation();

  useEffect(() => {
    window.location.href =
      'https://www.feirazerograu.com.br/2021/protocolo_feira_zerograu_2021.pdf';
  }, []);

  return (
    <div className="pagina-protocolo">
      <Styles />
      <Head
        title={t('paginas.traslado.titulo')}
        description={t('paginas.traslado.titulo')}
      />
    </div>
  );
};

export default Protocolo;
